var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppdone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8966 8.25337L18.7489 27.412C18.0021 28.1591 16.7958 28.1591 16.049 27.412L10.6302 21.9901C9.88346 21.2429 9.88346 20.0359 10.6302 19.2887C11.377 18.5415 12.5833 18.5415 13.3301 19.2887L17.3894 23.3503L35.1777 5.55202C35.9244 4.80483 37.1307 4.80483 37.8775 5.55202C38.6434 6.2992 38.6434 7.5062 37.8966 8.25338L37.8966 8.25337ZM27.327 2.21843C24.091 0.896483 20.4147 0.436676 16.5851 1.12639C8.79197 2.52497 2.56894 8.80898 1.24775 16.6065C-0.935099 29.5386 9.82595 40.6122 22.6741 38.9454C30.2566 37.9684 36.6137 32.3166 38.605 24.9405C39.3709 22.1242 39.4475 19.4037 39.0071 16.8556C38.7582 15.3229 36.8626 14.729 35.752 15.821C35.3116 16.2617 35.1201 16.9131 35.235 17.5261C35.6563 20.0742 35.4648 22.7948 34.2393 25.6877C32.0182 30.8797 27.193 34.6922 21.5827 35.2095C11.8173 36.11 3.7178 27.8335 4.92411 18.0051C5.74746 11.223 11.2046 5.70529 17.9637 4.76652C21.2763 4.30671 24.4165 4.93895 27.0972 6.31836C27.844 6.70153 28.7439 6.56742 29.3375 5.97351C30.2566 5.0539 30.0268 3.50205 28.878 2.90814C28.361 2.67823 27.844 2.42917 27.327 2.21843H27.327Z",
    fill: "#DCDCDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppdone);
export default __webpack_public_path__ + "static/media/app.done.d228c4014c0b9e16be2d0ee033bb0385.svg";
export { ForwardRef as ReactComponent };